export const URL_OK = process.env.REACT_APP_PAYMENT_OK
export const URL_KO = process.env.REACT_APP_PAYMENT_KO
